export const IRSDecision = {
  name: "irs-decision",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "irs.decision",
  showOn: [{ state: "primary", value: "irs-decision", operator: "is" }],
  allowCancel: true,
  allowCancelEvent: "main",
  children: [
    {
      name: "irs-decision-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "singleOption",
        optionName: "decision",
        layout: "type-button",
        prefix: "decision",
        children: ["upheld", "overturned"],
      },
      actionGroups: [
        {
          actions: [
            {
              action: "saveData",
              value: [{ option: "status", value: "COMPLETE" }],
              type: "options",
            },
            { action: "sendEvent", value: "edit", type: "main" },
            { action: "processInserts", value: "all", type: "inserts" },
            { action: "nextState", value: null, type: "primary" },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
